import { useState, useEffect, useRef } from "react";
import {
  postDoctors,
  postContentDiag,
  queryContentByDiagId,
  handleSoaRequest,
  recommendContentDiag, queryContentById,
} from "api/doctor-list";
import { useParams } from "react-router-dom";

// import { useMount } from "hooks/use-lifecycle";
import jdh from "../../asset/img/login/jdh.png";
import logo from "../../asset/img/login/logo.png";
import Prescribible from "../../asset/img/login/Prescribible.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Triple from "../../asset/img/login/Triple-A.png";
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";
import icon_right from "../../asset/img/login/icon_right.png";
import PcseoRecommondCard from '@jdh-cargo/block-pcseo-recommond-card';

import QRCode from "qrcode.react";
import { Popover } from "antd";
import styles from "./index.less"
import { onClickhref } from "utils";
import { ErrorComp } from "components/error";
import { getQrCodeUrl } from "utils/doctor";
import { recommendContentQaGW } from "api/hospital";

const wrong =
  'https://jkimg11.360buyimg.com/imagetools/jfs/t1/109795/12/29781/26449/6436a8faF68163c6d/ca252aa59b4641f3.png';

const Pccontent = () => {
  const params = useParams<Record<any, any>>();
  const [departData, setDepartData] = useState<any>();
  const [contentArticle, setContentArticle] = useState<any>();
  const [contentDiagData, setContentDiagData] = useState<any>();
  const [contentOtherArt, setContentOtherArt] = useState<any>();
  const [loading, setLoading] = useState(true);

  const [hasDoctor, setHasDoctor] = useState<any>(false);
  const [paragraphId, setParagraphId] = useState<any>();
  let isDoctor = useRef(false);
  let doctorId = useRef('');
  useEffect(() => {
    // console.log(params, 'params~~~~~~~~~');
    if (params.id) {
      setLoading(true);
      // 文章内容
      // handleSoaRequest({
      //   osName: 'content',
      //   venderId: '',
      //   inquiryTenancyId: '',
      //   tenantId: 287,
      //   version: 9,
      //   methodName: 'queryContentById116',
      //   contentId: parseInt(params.id),
      //   appId: 'c59cb704c24245a58768efa1ca1b4940',
      //   contentCopyright: {
      //     withCopyright: true,
      //     copyrightBusinessId: 359,
      //   }
      // })
      queryContentById(
          {
            venderId: '',
            inquiryTenancyId: '',
            tenantId: 287,
            contentId: parseInt(params.id),
            contentCopyright: {
              withCopyright: true,
              copyrightBusinessId: 359,
            }
          }
      ).then((res: any) => {
        setContentArticle(res);
        let author = res.authors;
        author?.some((item: any) => {
          if(item.authorType == 7) {
            isDoctor.current = true;
            doctorId.current = item.authorId;
            setHasDoctor(true);
            return;
          }
        });
        setLoading(false);
        if(isDoctor.current) {
          // 医生详细信息
          postDoctors({
            doctorId: doctorId.current,
            queryServiceAndTag: true,
          }).then((res: any) => {
            setDepartData(res);
          });
        }
      }).finally(() => {
        setLoading(false);
      });
      // 问诊记录
      // recommendContentDiag({
      //   osName: 'content',
      //   tenantId: 287,
      //   methodName: 'recommendContentDiag298',
      //   contentBusinessId: 305,
      //   contentId: parseInt(params.id),
      //   pageSize: 10,
      // })
      recommendContentQaGW({
        tenantId: 287,
        contentBusinessId: 305,
        contentId: parseInt(params.id),
        pageSize: 10,
      })
      .then((res: any) => {
        setContentDiagData(res);
      });
      // 其他文章
      handleSoaRequest({
        osName: 'content',
        venderId: '',
        inquiryTenancyId: '',
        tenantId: 287,
        version: 9,
        methodName: 'queryMoreContentArticle99',
        contentBusinessIds: [359],
        articleId: parseInt(params.id),
        recommendCount: 10,
        appId: 'c59cb704c24245a58768efa1ca1b4940',
        withContent: true,
      }).then((res: any) => {
        setContentOtherArt(res);
      });
    }
  }, []);

  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      // window.open("https://www.jdh.com/");
      window.open("https://cont.jd.com/");
    }
  };
  const qrCodeUrl = getQrCodeUrl(departData?.docId);
  const content = (
    <div className={styles.overbookingCodebotton}>
      <QRCode value={qrCodeUrl} size={80} />
      <div>
        <h3>扫码关注医生</h3>
        <h6>关注{departData?.docName}医生，方便随时提问</h6>
      </div>
    </div>
  );

    const deleteTag = (html: string) => html
    ?.replace(/<.+?>/g, '')
    ?.replace(/<\/.+>/g, '')
    ?.replace(/\s+/g, ' ')
    ?.replace(/<img.+\/>/ig, '')
    ?.replace(/\%/g, '')
    ?.trim();

  return (
    <div className={styles.pccontent}>
      {
        !loading && !contentArticle && <ErrorComp />
      }
      {/* 描述信息 */}
      {
        !loading && contentArticle && contentArticle.contentStatus === 1 &&
        <div className={styles.describe}>
          <p>
            当前位置：
            <i
              data-a-href="/"
              data-a-nofollow="true"
              onClick={() => {
                setTimeout(() => {
                  onClickOpen();
                }, 200);
              }}
            >
              首页
            </i>
            <span>{">"}</span>
            {departData?.hospitalName && departData?.docName ? (
              <>
                <a
                  onClick={() => {
                    onClickOpen("/hospital/" + departData?.hospitalId);
                  }}
                  data-a-href={"/hospital/" + departData?.hospitalId}
                >{departData?.hospitalName}</a>
                {departData?.hospitalName && <span>{">"}</span>}
                {/* {departData?.docName} */}
                <span
                  data-a-href={
                    departData?.doctorSource === 1 ? `/yellowdoctor/${departData?.docId}` : `/doctor/${departData?.docId}`
                  }
                  onClick={() => {
                    let url = `/doctor/${departData?.docId}`;
                    if (departData?.doctorSource === 1) {
                      url = `/yellowdoctor/${departData?.docId}`;
                    }
                    onClickOpen(url);
                  }}
                  data-tag-h1
                >
                  {departData?.docName}</span>
                <span>{">"}</span>
              </>
            ) : null}
          </p>
          {contentArticle && contentArticle?.contentParagraphs && (
            <h1 className={styles.describe1} data-tag-h1>
              {contentArticle.contentName}
            </h1>
          )}
        </div>
      }
      {/* 内容 */}
      {
        !loading && contentArticle &&
        <div className={styles.content}>
          {/* 左 */}
          <div className={styles.left}>
            {/* 文章内容信息 */}
            {contentArticle && contentArticle.contentStatus === 1 ? (
              <div className={styles.essayInfo}>
                <div className={styles.essayInfoTit}>{contentArticle.contentName}</div>
                {
                  hasDoctor ? contentArticle?.authors?.map((item: any) => {
                    if(item.authorType == 7) {
                      return(
                        <div className={styles.essayInfoTip} key={item.authorName}>
                          <span>发表人：</span>
                          <span className={styles.essayInfoTipName}>{item.authorName}</span>
                        </div>
                      )
                    }
                  })
                  :
                  contentArticle?.authors?.map((item: any) => {
                    if(item.authorType == 1) {
                      return(
                        <div className={styles.essayInfoTip} key={item.authorName}>
                          <span>发表人：</span>
                          <span className={styles.essayInfoTipName}>{item.authorName}</span>
                        </div>
                      )
                    }
                  })
                }
                {
                  contentArticle?.contentParagraphs?.map((item: any) => {
                    return (
                      <div className={styles.essayInfoCon} key={item}>
                        <p dangerouslySetInnerHTML={{ __html: item.paragraphContent }}></p>
                      </div>
                    )
                  })
                }
                {
                  contentArticle?.contentVideos?.map((item: any) => {
                    return (
                      <div
                        className={styles.essayInfoVideo}
                        // onClick={videoPlay}
                        key={item.playUrl}
                      >
                        <video
                          id="artcleVideo"
                          className={styles.video}
                          playsInline
                          webkit-playsinline="true"
                          x-webkit-airplay="true"
                          src={item.playUrl}
                          width="100%"
                          controls
                        />
                      </div>
                    )
                  })
                }
                <div className={styles.essayInfoTitImg}>
                  <img src={jdh} alt="" style={{marginTop: '3px'}}/>
                  <div>
                    <p>{contentArticle?.copyright}</p>
                    <p>本站内容仅供医学知识科普使用，任何关于疾病、用药建议都不能替代执业医师当面诊断，请谨慎参阅</p>
                  </div>
                </div>
              </div>
            ) :
              <div className={styles.wrong}>
                <img src={wrong} alt="" />
                <p>很抱歉，内容已下线～</p>
              </div>
            }

            {/* 与医生的问诊记录 */}
            {contentDiagData && contentDiagData?.length > 0 && (
              <div className={styles.consultationList}>
                <div className={styles.consultationListTit}>
                  {
                    hasDoctor ?
                    <div
                      onClick={() => {
                        window.open("https://cont.jd.com/qalist/" + departData?.docId)
                      }}
                    >
                      推荐问诊记录
                    </div>
                    : <div>推荐问诊记录</div>
                  }
                  {

                    hasDoctor ?
                    <a
                      className={styles.consultationListTitInfo}
                      href={"https://cont.jd.com/qalist/" + departData?.docId}
                      target="_blank"
                    >
                      <span
                        data-a-href={"/qalist/"+ departData?.docId}
                        data-a-nofollow="true"
                      >
                        查看全部
                      </span>
                    </a>
                    : ""
                  }

                </div>
                <ul>
                  {contentDiagData&& contentDiagData.map((itme: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          setTimeout(() => {
                            let diagid = itme?.contentDiags[0]?.diagId;
                            window.open(
                              window.location.origin +
                                "/qa" +
                                "/" +
                                diagid
                            );
                          }, 200);
                        }}
                        data-a-nofollow="true"
                      >
                        <div className={styles.consultationListTop}>
                          <div
                            className={styles.consultationListTopText}
                            data-a-href={
                              "/qa/" +
                              itme?.contentDiags[0]?.diagId
                            }
                          >
                            {itme?.contentName}
                          </div>
                          <div className={styles.consultationListTopInfo}>
                            <span
                            >
                              点击查看
                            </span>
                            <img src={icon_right} alt="" />
                          </div>
                        </div>
                        <div className={styles.consultationListBon}>
                          <div className={styles.consultationListBonLeft}>
                            <div className={styles.consultationListBonLeftText1}>
                              <h3>总交流次数</h3>
                              <h5>
                                {itme?.contentDiags&&itme?.contentDiags[0]?.doctorExchangeCount +
                                  itme?.contentDiags[0]?.patientExchangeCount ||
                                  0}
                              </h5>
                            </div>
                            <div className={styles.consultationListBonLeftLine} />
                            <div className={styles.consultationListBonLeftText2}>
                              <h3>医生回复次数</h3>
                              <h5>
                                {itme?.contentDiags && itme?.contentDiags[0]?.doctorExchangeCount || 0}
                              </h5>
                            </div>
                          </div>
                          <div className={styles.consultationListBonInfo}>
                            <span>患者：</span>
                            <h4>
                              {itme?.contentDiags && itme?.contentDiags[0]?.patientSex == 1
                                ? "男 "
                                : "女 "}
                              {itme?.contentDiags && itme?.contentDiags[0]?.patientAge || 0}
                            </h4>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            {/* 医生的其他文章 */}
            {contentOtherArt && contentOtherArt?.length > 0 && (
              <div className={styles.articleList}>
                <div className={styles.articleListTit}>
                  <div>推荐科普文章</div>
                  {/* <a
                    className={styles.articleListTitInfo}
                  >
                    <span
                      data-a-href={"/qalist/"}
                      data-a-nofollow="true"
                    >
                      查看全部
                    </span>
                  </a> */}
                </div>
                <ul>
                  {contentOtherArt.map((itme: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          window.open(window.location.origin + "/pccontent/"+ itme?.id);
                        }}
                        data-a-nofollow="true"
                      >
                        <div className={styles.articleListTop}>
                          <div
                            className={styles.articleListTopText}
                            data-a-href={
                              "/pccontent/" +
                              itme?.id
                            }
                          >
                            {itme?.title}
                          </div>
                          <div className={styles.articleListTopInfo}>
                            <span>
                              点击查看
                            </span>
                            <img src={icon_right} alt="" />
                          </div>
                        </div>
                        <div className={styles.consultationListBon}>
                          <div className={styles.consultationListBonLeft}>
                            <div className={styles.consultationListBonLeftText1}>
                              {
                                <h3 dangerouslySetInnerHTML={{ __html: deleteTag(itme?.content) }}></h3>
                              }
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {/* 网站地图 */}
            {/* <div className={styles.sitemap}>
              <a href="https://www.jdh.com/sitemap.html" rel="nofollow">
                网站地图
              </a>
            </div> */}
          </div>
          {/* 右 */}
          <div className={styles.right}>
            <div className={styles.rightFloat}>
              {departData?.docName && contentArticle.contentStatus === 1 && (
                <div
                  className={styles.doctorInfo}
                  onClick={() => {
                    if (departData.docId) {
                      setTimeout(() => {
                        onClickOpen(
                          window.location.origin + "/doctor/" + departData.docId
                        );
                      }, 200);
                    }
                  }}
                >
                  <div className={styles.doctorInfoTit}>接诊医生</div>
                  <div className={styles.doctorInfoImg}>
                    <img
                      src={
                        "https://image.healthjd.com/nethpim/" +
                        departData?.doctorHeadImg
                      }
                      alt={departData?.docName}
                    />
                    <div className={styles.doctorInfoImgRight}>
                      <div className={styles.doctorInfoImgTop}>
                        {departData?.selfSupport && (
                          <img src={selfSupport} alt="" />
                        )}
                        {departData?.operationalOpenRxStatus === 1 && (
                          <img src={Prescribible} alt="" />
                        )}
                        <div className={styles.doctorInfoImgTopName}>
                          {departData?.docName}
                        </div>
                        <span>{departData?.titleName}</span>
                      </div>
                      <div className={styles.doctorInfoImgBotton}>
                        {departData?.hospitalGrade === 3 && (
                          <img src={Triple} alt="" />
                        )}
                        <p>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              onClickOpen("/hospital/" + departData?.hospitalId);
                            }}
                            data-a-href={"/hospital/" + departData?.hospitalId}
                          >
                            {departData?.hospitalName}
                          </span>
                          {' '}
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              onClickOpen(`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`)
                            }}
                            data-a-href={`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`}
                          >
                            {departData?.secondDepartName}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={styles.doctorInfoText}>
                    擅长: {departData?.docGoodAt || "无"}
                  </div>
                  <div className={styles.doctorInfoNum}>
                    <div className={styles.doctorInfoNum1}>
                      <h2>好评率</h2>
                      <h5>
                        {Math.floor(departData?.patientEvaluationRate * 100) || 0}%
                      </h5>
                    </div>
                    <div className={styles.doctorInfoLine}></div>
                    <div className={styles.doctorInfoNum2}>
                      <h2>在线问诊量</h2>
                      <h5>{departData?.receivePatientNum || 0}</h5>
                    </div>
                  </div>
                  <div className={styles.doctorInfoBut}>立即咨询</div>
                </div>
              )}
              {
                departData?.docName ?
                <div className={styles.overbookingCode}>
                  <QRCode
                    id="qrCode"
                    value={
                      hasDoctor
                        ? getQrCodeUrl(departData?.docId)
                        : ""
                    }
                    size={80}
                  />
                  <div>
                    <h3>扫一扫 立即下单</h3>
                    <h6>仅支持手机扫码购买</h6>
                  </div>
                </div>
                :
                // <div className={styles.overbookingCode}>
                //   <QRCode
                //     id="qrCode"
                //     value={
                //       "https://cont.jd.com/content/" + params.id

                //     }
                //     size={80}
                //   />
                //   <div>
                //     <h3> 快速问医生</h3>
                //     <h6>立即扫码咨询</h6>
                //   </div>
                // </div>
                <PcseoRecommondCard />
              }
            </div>
          </div>
        </div>
      }
      <div className={styles.footerData} id="m_common_bottom">
        {/* <h2 className={styles.footerDataInvestor}>
          <a href="https://m.360buyimg.com/babel/jfs/t1/181014/6/22558/388522/62568785E608ef36a/d9ccabbcd5f95057.png!q20.webp">
            营业执照
          </a>
          <a href="https://ir.jdhealth.com/sc/index.php"> Investor Relations</a>
        </h2>
        <p>违法和不良信息举报电话：4006561155 消费者维权热线：4006067733</p>
        <p>Copyright © 2020 jdjiankang.com 版权所有</p>
        <h2 className={styles.footerDataImg}>
          <img src={beian} alt="" />
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050202000590">
            桂公网安备 45050202000590号
          </a>
          <a href="https://beian.miit.gov.cn/">桂ICP备202200128-5</a>
        </h2> */}
      </div>
      {/* 底部 */}
      { departData && departData?.docName && contentArticle.contentStatus === 1 && (
        <div className={styles.bottom}>
          <div className={styles.bottomDoctorInfo}>
            {departData && departData?.docName && (
              <>
                <img
                  src={
                    "https://image.healthjd.com/nethpim/" +
                    departData?.doctorHeadImg
                  }
                  alt={departData?.docName}
                />
                <div className={styles.doctorInfoImgRight}>
                  <div className={styles.doctorInfoImgTop}>
                    <div className={styles.doctorInfoImgTopName}>
                      {departData?.docName}
                    </div>
                    <span>{departData?.titleName}</span>
                    <p>已认证</p>
                  </div>
                  <div className={styles.doctorInfoImgBotton}>
                    {departData?.hospitalGrade === 3 && (
                      <img src={TripleHospital} alt="" />
                    )}
                    <p>
                      {departData?.hospitalName} {departData?.secondDepartName}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className={styles.bottomBtn}>
            <button
              className={styles.bottomBtn1}
              onClick={() => {
                setTimeout(() => {
                  onClickOpen(window.location.origin + "/doctor/" + departData.docId);
                }, 200);
              }}
            >
              立即咨询
            </button>
            <Popover content={content}>
              <button className={styles.bottomBtn2}>
                扫码关注医生，方便随时咨询
              </button>
            </Popover>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pccontent;
